'use client';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Input from '../input/Input';

const selectionSupportedFieldTypes = [
  'text',
  'search',
  'url',
  'tel',
  'password',
];

class InputManageCursor extends PureComponent {
  static propTypes = {
    ...Input.propTypes,
    manageCursorHelper: PropTypes.func,
  };

  static defaultProps = {
    ...Input.defaultProps,
    manageCursorHelper: (diff) => diff,
  };

  constructor(props) {
    super(props);
    this.currIndex = 0;
    this.newIndex = 0;
    this.selectionSupported =
      selectionSupportedFieldTypes.indexOf(this.props.type) > -1;
    this.selectionUpdated = false;

    this.keyUpCallback = get(this.props, 'extensionProps.onKeyUp', () => {});
    this.keyDownCallback = get(
      this.props,
      'extensionProps.onKeyDown',
      () => {}
    );
  }

  componentDidUpdate(prevProps) {
    // console.warn('componentDidUpdate', this.props, this.selectionSupported);

    if (this.selectionSupported) {
      const value = this.props.value;
      const valueLength = value.length;
      const prevValueLength = (prevProps.value || '').length;

      if (valueLength > prevValueLength) {
        let diff = valueLength - prevValueLength;
        if (diff > 0) {
          diff = this.props.manageCursorHelper(diff, value, this.currIndex);
          this.newIndex = this.currIndex + diff;

          // console.warn(`onUpdate setSelectionRange: ${this.newIndex} diff: ${this.diff}`);
          this.Input.input.setSelectionRange(this.newIndex, this.newIndex);
          this.selectionUpdated = true;
        }
      }
    }
  }

  // We need this onKeyUp as a backup to re-enforce cursor position on Android
  onKeyUp = (evt) => {
    if (this.selectionSupported && this.selectionUpdated) {
      if (this.Input.input.selectionStart !== this.newIndex) {
        // console.warn(`--------------------- onKeyUp: selectionStart: ${this.Input.input..selectionStart} selectionStart: ${this.newIndex}`);
        this.Input.input.setSelectionRange(this.newIndex, this.newIndex);
      }
    }
    this.keyUpCallback(evt);
  };

  onKeyDown = (evt) => {
    this.selectionUpdated = false;
    if (this.selectionSupported) {
      this.currIndex = this.Input.input.selectionStart;
    }
    this.keyDownCallback(evt);
  };

  /* Placeholder for when we implement copy / paste functionality in Inputs
   onPaste = (evt) => {
   // TODO: Check getData('Text') works on all browsers
   console.warn(`onPaste ${evt.clipboardData.getData('Text')}`);
   this.pasteText = evt.clipboardData.getData('Text');
   }; */

  render() {
    return (
      <Input
        {...this.props}
        ref={(el) => {
          this.Input = el;
        }}
        data-jlds={true}
        extensionProps={{
          ...this.props.extensionProps,
          onKeyDown: this.onKeyDown,
          onKeyUp: this.onKeyUp,
        }}
      />
    );
  }
}

export default InputManageCursor;
